var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 1079,
    viewBox: "0 0 768 1079",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6239 1134.12C-241.438 987.531 -153.437 584.646 55.5942 438.75C133.932 384.175 229.521 355.133 325.133 355.841C411.364 356.665 520.835 372.363 603.656 328.717C666.352 295.39 688.995 229.431 716.451 168.619C792.632 -0.524185 1030.14 -59.6379 1168.36 74.6489C1219.38 124.194 1246.85 198.574 1233.58 268.593C1202 431.179 1023.04 385.444 936.746 481.195C902.317 519.38 900.296 587.487 883.204 635.013C865.724 683.63 842.849 730.826 817.663 776.22C764.778 872.016 697.058 961.816 615.289 1035.08C452.264 1181.56 233.706 1246.16 29.4464 1143.52C23.8601 1140.56 18.2738 1137.6 12.6239 1134.12Z",
    fill: "url(#paint0_radial_105_843)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_105_843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(824.689 106.339) rotate(-129.53) scale(1705.4 2866.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveT);
export default __webpack_public_path__ + "static/media/wave_t.4e26cbf50ac121bc16ab3146db7fe917.svg";
export { ForwardRef as ReactComponent };